import React from 'react';
import {
  RadioGroupContainer,
  RadioButtonsWrapper,
  Label,
  DisabledFieldset,
} from './radio-group.styles';

export interface RadioProps {
  label?: string;
  direction?: 'row' | 'column';
  children: React.ReactNode;
  disabled?: boolean;
}

const RadioGroup = ({ direction, label, disabled, children }: RadioProps) => (
  <DisabledFieldset
    disabled={disabled}
    role='radiogroup'>
    <RadioGroupContainer>
      {label && <Label as='p'>{label}</Label>}
      <RadioButtonsWrapper $direction={direction}>
        {children}
      </RadioButtonsWrapper>
    </RadioGroupContainer>
  </DisabledFieldset>
);

export default RadioGroup;
